import script from "./asset-list.vue?vue&type=script&lang=js"
export * from "./asset-list.vue?vue&type=script&lang=js"

import "./asset-list.vue?vue&type=style&index=0&id=0f0b909b&lang=scss"

const __exports__ = script;

export default __exports__